export default __webpack_public_path__ + "adobe-photoshop.56c6b31c.png";